import React from 'react'
import { useNavigate } from 'react-router-dom'
import Sidebar from './common/Sidebar'; // Assuming Sidebar is in ../components
import './SuperAdminDashboard.css' // Import the updated CSS file

const SuperAdminDashboard = () => {
    const navigate = useNavigate()

    const handleNavigation = (path) => {
        if (path) {
            navigate(path)
        } else {
            console.warn('Navigation path is undefined for this action.')
            alert('This feature is coming soon!')
        }
    }

    const actionGroups = [
        {
            groupTitle: 'User Management',
            items: [
                {
                    label: 'Manage All Users',
                    icon: 'ri-group-line',
                    path: '/admin/users/manage',
                },
                {
                    label: 'Add New Super Admin',
                    icon: 'ri-admin-line',
                    path: '/admin/register',
                },
                {
                    label: 'Add New Business Admin',
                    icon: 'ri-user-settings-line',
                    path: '/admin/business-admin/new',
                },
            ],
        },
        {
            groupTitle: 'Business Operations',
            items: [
                {
                    label: 'Add New Business',
                    icon: 'ri-building-4-line',
                    path: '/admin/business/new',
                },
                {
                    label: 'Manage Businesses',
                    icon: 'ri-store-2-line',
                    path: '/admin/business/manage',
                },
                {
                    label: 'Approve Business Requests',
                    icon: 'ri-checkbox-multiple-line',
                    path: '/admin/business/requests',
                },
            ],
        },
        {
            groupTitle: 'Survey Management',
            items: [
                {
                    label: 'Create New Survey',
                    icon: 'ri-add-circle-line',
                    path: '/create-survey',
                },
                {
                    label: 'View/Manage All Surveys',
                    icon: 'ri-list-check-2',
                    path: '/savedsurveys',
                },
            ],
        },
    ]

    return (
        <div className="test-container"> {/* This remains as a global layout class */}
                  <div >
      <Sidebar />
      </div>
            <div className="sad-dashboard-page"> {/* Renamed */}
                <div className="sad-dashboard-header"> {/* Renamed */}
                    <h1 className="sad-dashboard-title page-title">Super Admin Panel</h1> {/* Renamed */}
                    <p className="sad-dashboard-subtitle"> {/* Renamed */}
                        Oversee and manage all aspects of the Eclipseer platform.
                    </p>
                </div>

                <div className="sad-dashboard-grid"> {/* Renamed */}
                    {actionGroups.map(
                        (group, groupIndex) =>
                            group.items.length > 0 && (
                                <div className="sad-dashboard-card" key={groupIndex}> {/* Renamed */}
                                    <h2 className="sad-card-title">{group.groupTitle}</h2> {/* Renamed */}
                                    <div className="sad-card-actions"> {/* Renamed */}
                                        {group.items.map((action, actionIndex) => (
                                            <button
                                                key={actionIndex}
                                                className="sad-dashboard-button" // Renamed
                                                onClick={() => handleNavigation(action.path)}
                                            >
                                                <i className={action.icon}></i>
                                                <span>{action.label}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )
                    )}
                </div>
            </div>
        </div>
    )
}

export default SuperAdminDashboard;